import Head from "next/head";

function SharedJobHeader(props) {
  // Checks company name to exclude trailing words
  let companyNameInput = props.job?.company?.name;
  let metaIndex = props.job?.expired;
  let excludedWords = [
    "sdn. bhd.",
    "sdn bhd",
    "sendirian bhd",
    "sdn berhad",
    "sendirian berhad",
  ];
  let regex = new RegExp("\\b(" + excludedWords.join("|") + ")\\b", "gi");
  let companyName = companyNameInput.replace(regex, "").trim();

  let metaTitle =
    props.job == undefined
      ? "New Jobs in Malaysia | Hiredly - Where good careers are built"
      : props.job?.company?.id === "750524cc-6b5d-48c8-8438-0b5b1c3f6aea"
        ? `${props.job?.title} could be your next role | Hiredly X Malaysia`
        : `${props.job?.title} at ${companyName} | Hiredly Malaysia`;

  let metaDescription =
    props.job == undefined
      ? "Explore the latest job vacancies in Malaysia on Hiredly. Search by role, company, and location, then apply with confidence to find the right career move."
      : props.job?.company?.id === "750524cc-6b5d-48c8-8438-0b5b1c3f6aea"
        ? "Apply through Hiredly X and let our headhunters match you with relevant opportunities in Malaysia based on your skills, goals, and preferred role."
        : `Apply for ${props.job?.title} at ${companyName} on Hiredly Malaysia. Review responsibilities, requirements, and company details before submitting your application.`;

  const job = props.job;
  const structuredJobData = job?.structuredJobData;

  const hasDescription =
    typeof structuredJobData?.description === "string" &&
    structuredJobData.description.trim().length > 0;

  const shouldRenderJobPosting =
    job?.active === true &&
    job?.expired === false &&
    structuredJobData?.["@type"] === "JobPosting" &&
    hasDescription;

  return (
    <Head>
      {/* <!-- Google jobs structured data --> */}
      {shouldRenderJobPosting && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(structuredJobData),
          }}
        />
      )}

      {/* <!-- Primary Meta Tags --> */}
      <title>{metaTitle}</title>
      <meta property="" content="initial-scale=1.0, width=device-width" />
      <meta name="title" content={metaTitle} />
      <meta name="description" content={metaDescription} />
      {/* {metaIndex && <meta name="robots" content="noindex, nofollow" />} */}

      {/* <!-- Open Graph / Facebook --> */}
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content={`https://my.hiredly.com/jobs/${props.job?.slug}`}
      />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={`https:` + props.job?.imageThumb} />

      {/* <!-- Twitter --> */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta
        property="twitter:url"
        content={`https://my.hiredly.com/jobs/${props.job?.slug}`}
      />
      <meta property="twitter:title" content={metaTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta
        property="twitter:image"
        content={`https:` + props.job?.imageThumb}
      />

      <link
        rel="canonical"
        href={`https://my.hiredly.com/jobs/${props.job?.slug}`}
      />
    </Head>
  );
}

export default SharedJobHeader;
